import { render, staticRenderFns } from "./EducationDetails.vue?vue&type=template&id=46083780&"
import script from "./EducationDetails.vue?vue&type=script&lang=js&"
export * from "./EducationDetails.vue?vue&type=script&lang=js&"
import style0 from "./EducationDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports